//注入按钮
import "./sysButton";
import DsfExamLayout from "./components/ExamLayout";
import DsfExamItem from "./components/ExamItem";
import DsfExamItemBox from "./components/ExamItemBox";
import DsfSettingFontSize from "./components/settingFontSize";
import DsfTestPaperComponent from "./components/TestPaperComponent";
import DsfCardSimpleStyle from "./components/CardSimpleStyle.vue";
import DsfCardGraceStyle from "./components/CardGraceStyle.vue";
const components = [
  DsfExamLayout,
  DsfExamItem,
  DsfExamItemBox,
  DsfSettingFontSize,
  DsfTestPaperComponent,
  DsfCardSimpleStyle,
  DsfCardGraceStyle
]
function install(Vue) {
  components.forEach((it) => {
    Vue.component(it.name, it);
    if (!window.$components['exam']) {
      window.$components['exam'] = {}
    }
    window.$components['exam'][it.name] = it;
  })
}
export default install;

export { install };
